"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cobalt_design = require("@cobalt/cobalt_design");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var fallbackBreakpoints = {
  small: {
    min: 0,
    max: 640
  },
  medium: {
    min: 641,
    max: 960
  },
  large: {
    min: 961,
    max: Infinity
  }
};

function verifyEdges(obj) {
  if (!obj) return;
  Object.keys(obj).forEach(function (breakpoint) {
    if (_typeof(obj[breakpoint]) !== 'object') return;

    if (!Object.prototype.hasOwnProperty.call(obj[breakpoint], 'min')) {
      obj[breakpoint].min = 0;
    }

    if (!Object.prototype.hasOwnProperty.call(obj[breakpoint], 'max')) {
      obj[breakpoint].max = Infinity;
    }
  });
}

var BREAKPOINTS = _cobalt_design.BREAKPOINTS ? Object.assign({}, _cobalt_design.BREAKPOINTS, verifyEdges(_cobalt_design.BREAKPOINTS)) : fallbackBreakpoints;
var _default = BREAKPOINTS;
exports.default = _default;